<template>
    <div class="model">
        <div v-if="brandList.length">
            <div class="modelList">
                <div class="modelLi" v-for="item in brandList" :key="item.id">
                    <div class="item" @click="onModel(item.id, item.name)">
                        <div class="img">
                            <img :src="$viewImageNew(item.logoUrl, 400,400)" alt="">
                        </div>
                        <p v-text="item.name"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="msg" v-else>
            <img src="../../../../assets/img/b2b/img_empty_order@2x.png" alt="">
            暂无品牌
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    name: 'modelList',
    data () {
        return {
            title: '品牌',
            titleRight: '',
            brandList: [],
            userInfo: ''
        }
    },
    methods: {
        ...mapActions(['getbrandListData']),
        onBack () { // 返回
            this.$router.push({ path: '/b2b/home/index' })
        },
        onModel (id, name) {
            let names = name
            localStorage.removeItem('activityData')
            localStorage.setItem('goodsListBack', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/goods/goodsList', query: { brandId: id, name: names, screenType: 1, tabNav: 2 } })
        },
        getbrandList () {
            this.getbrandListData({
                status: 1,
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            }).then((data) => {
                this.brandList = data
            })
        }
    },
    activated () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (this.$route.meta.isUseCaChe) {
            this.getbrandList()
        }
    },
    async mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        await this.getbrandList()
    }
}
</script>
<style lang="scss" scoped>
    .model{
        padding: 0 20px;
        padding-bottom: 50px;
        background: #f5f5f5;
        .modelList{
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            align-content: flex-start;
            .modelLi{
                width: 33.33%;
                display: flex;
                justify-content: center;
                .item{
                    width: 218px;
                    margin-top: 20px;
                    .img{
                        height: 218px;
                        box-shadow: 0px 2px 10px 2px rgba(0,0,0,0.06);
                        border-radius: 12px;
                        padding: 0 30px;
                        background: #ffffff;
                        overflow: hidden;
                        display: flex;
                        img{
                            align-self: center;
                            justify-self: center;
                            margin: 0 auto;
                        }
                    }
                    p{
                        font-size: 28px;
                        text-align: center;
                        margin-top: 12px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                    }
                }
            }
        }
        .msg{
            width: 182px;
            font-size: 26px;
            color: #c7c7cc;
            margin: 0 auto;
            padding-top: 160px;
            text-align: center;
            img{
                width: 176px;
                height: 176px;
                margin: 0 auto;
            }
        }
    }
</style>
